import { InjectionToken } from '@angular/core';

export const ProductTypes = {
  EmployeeAccount: ['03110001001', '03110001003', '0311A001005', '0311A001008', '0311A001010', '0311A001013', '0311A001015', '0311A001017', '0311A001019', '0311A001021', '0311A001023', '0311A001025', '0311A001027', '0311A001029', '0311A001031', '0311A001033', '0311A001035','0311A001037', '0311A001039', '0311A001041', '0311A001043', '0311A001045'],
  Account: ['03110001002', '03110001004', '03110001C04', '0311A001006', '0311A001009', '0311A001011', '0311A001012', '0311A001014', '0311A001016', '0311A001018', '0311A001020', '0311A001022', '0311A001024', '0311A001026', '0311A001028', '0311A001030', '0311A001032', '0311A001034', '0311A001036', '0311A001038', '0311A001040', '0311A001042', '0311A001044','0311A001046'],
  EmployeeDeposit: ['03510001001', '03510001003', '03510001005'],
  Deposit: ['03510001002', '03510001004', '03510001006'],
};

export const PRODUCT_TYPES = new InjectionToken('PRODUCT_TYPES', {
  providedIn: 'root',
  factory: () => ProductTypes,
});
